import React, { useContext, useState } from 'react';

import { useParams } from '../../hooks/useParams';
import { DataLayerContext } from '../dataLayer';

export const DataLayerProvider = ({ children }) => {
  // Get eventsorting param from customio
  const { param } = useParams('eventsorting', true);
  const [eventsorting, setEventSorting] = useState(param || 1);

  return (
    <DataLayerContext.Provider
      value={{
        setEventSorting,
        eventsorting
      }}
    >
      {children}
    </DataLayerContext.Provider>
  );
};
